/* eslint-disable @typescript-eslint/naming-convention */
import './OfferSearchFiltersMoreButton.css';

/* eslint-disable complexity */
import React, { useCallback, useEffect, useRef } from 'react';
import { Modal as DSModal, Button, Typography } from '@vtblife/uikit';

import { useModal } from '@search/vtbeco-ui/src/components/Modal';
import { formatNumber } from '@search/helpers/src/formatNumber';
import classname from '@search/classname/src';
import {
    Filters,
    IFilter,
    CategoryTypeFilter
} from '@search/vtbeco-frontend-core/view/filters/models/Filter';
import { BalconyNewFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/balcony/BalconyNewFilter';
import { WindowDirectionNewFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/windowsDirection/WindowsDirectionNewFilter';
import { NearbySchoolButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/nearby_school/NearbySchoolButtonFilterView';
import { RenovationProgramButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/renovation_program/RenovationProgramButtonFilterView';
import { DesktopWallsButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/walls/DesktopWallsButtonFilterView';
import { FurnitureButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/furniture/FurnitureButtonFilterView';
import { LivingFacilityButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/living_facility/LivingFacilityButtonFilterView';
import { ApartmentButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/apartments/ApartmentButtonFilterView';
import { DesktopRoomsInOfferFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/roomInOffer/DesktopRoomsInOfferFilterView';
import { DesktopRoomInFlatFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/roomInFlat/DesktopRoomInFlatFilterView';
import { DesktopLandAreaFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/landArea/DesktopLandAreaFilterView';
import { DesktopRoomInHouseFilterSelectView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/roomInHouse/DesktopRoomInHouseFilterSelectView';
import { DesktopHouseAreaFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/houseArea/DesktopHouseAreaFilterView';
import { PrePaymentButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/pre_payment/PrePaymentButtonFilterView';
import { RentConditionButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/rent_conditions/RentConditionButtonFilterView';
import { LivingAreaFromFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/living_area/LivingAreaFromFilter';
import { KitchenAreaFromFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/kitchen_area/KitchenAreaFilter';
import { FloorFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/floor/FloorFilter';
import { FloorsTotalFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/floors_total/FloorsTotalFilter';
import { CeilHeightNewFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/ceil_height/CeilHeightNewFilterView';
import { BathroomNewFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/bathroom/BathroomNewFilter';
import { AreaFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/area/AreaFilter';
import { SellTypeSelectFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/sell_type/SellTypeSelectFilter';
import { YearBuildingFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/year_building/YearBuildingFilter';
import { SellerFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/seller/SellerFilter';
import { RenovationNewFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/renovation/RenovationNewFilter';
import { InfrastructureButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/group/InfrastructureButtonFilterView';
import { AdditionalButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/group/AdditionalButtonFilterView';
import { SupplyOptionsButtonFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/group/SupplyOptionsButtonFilterView';
import { ClassifiedFilterCollection } from '@search/vtbeco-frontend-core/domain/offer/filters/ClassifiedFilterCollection';
import { TransportLimitNewFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/mobile/transportLimit/TransportLimitNewFilter';
import { DesktopLandStatusFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/landStatus/DesktopLandStatusFilterView';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { getAnalyticsFiltersString } from '@search/vtbeco-frontend-core/domain/offer/search/page/getAnalyticsFiltersString';
import { SearchRoute, useRouter } from '@search/offer-search-routes/src';
// import { ClPromoRieltorsTrigger } from '@search/classified-common/src/ClPromoRieltorsTrigger/ClPromoRieltorsTrigger';

import { RealtyObjectType } from '@search/filter-enums/enums';
import type { TipItem } from '@search/vtbeco-frontend-core/view/tips/OffersSearchTips';
import { FinishingFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/finishing/FinishingFilterView';
import { CommissioningDateFilter } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/commissioning_date/CommissioningDateFilter';

const cn = classname.bind(null, 'OffersSearchFiltersMoreButton');

interface OffersSearchFiltersMoreButtonProps {
    filters: ClassifiedFilterCollection;
    count: number;
    openExtraFilter: () => void;
    closeExtraVisible: () => void;
    extraFilterVisible: boolean;
    updateFilter: (filter: IFilter) => void;
    updateFewFilters: (filters: IFilter[]) => void;
    handleSubmit: () => void;
    handleReset: () => void;
    handleMapSearch: () => void;
    tipsAnalytics: TipItem[];
    showPromoRieltors: boolean;
}

export const OffersSearchFiltersMoreButton: React.FC<OffersSearchFiltersMoreButtonProps> = ({
    filters,
    count,
    updateFilter,
    updateFewFilters,
    extraFilterVisible = false,
    openExtraFilter = () => {},
    closeExtraVisible = () => {},
    handleSubmit = () => {},
    handleReset = () => {},
    handleMapSearch = () => {},
    tipsAnalytics,
    // showPromoRieltors
}) => {
    const {
        on,
        off,
        visible
    } = useModal();
    const isShowModal = extraFilterVisible && visible;

    const router = useRouter();
    const searchRoute = router.route(SearchRoute);
    const searchParams = searchRoute.params();

    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const handleOpen = useCallback(() => {
        dataLayerPush({
            event: 'classified_more_filter_click_button',
            params: getAnalyticsFiltersString({
                tipsAnalytics,
                searchParams,
                region: searchRoute.regionSlugPath(searchParams.region) as string
            })
        });
        openExtraFilter();
        on();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ on, openExtraFilter, dataLayerPush, searchParams, tipsAnalytics ]);

    const handleFillingFiltersEnd = useCallback(() => {
        dataLayerPush({
            event: 'classified_more_filter_show_result',
            params: getAnalyticsFiltersString({
                tipsAnalytics,
                searchParams,
                region: searchRoute.regionSlugPath(searchParams.region)
            })
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ dataLayerPush, searchParams, tipsAnalytics ]);

    const handleClose = useCallback(() => {
        handleFillingFiltersEnd();
        closeExtraVisible();
        off();
    }, [ closeExtraVisible, off, handleFillingFiltersEnd ]);

    const onSubmit = useCallback(() => {
        handleFillingFiltersEnd();
        handleSubmit();
    }, [ handleSubmit, handleFillingFiltersEnd ]);

    const onSwitchMap = useCallback(() => {
        handleFillingFiltersEnd();
        handleMapSearch();
    }, [ handleMapSearch, handleFillingFiltersEnd ]);

    const firstInteraction = useRef(true);
    const handleInteraction = useCallback(() => {
        if (firstInteraction.current) {
            firstInteraction.current = false;
            dataLayerPush({ event: 'classified_more_filter_start_fill' });
        }
    }, [ dataLayerPush ]);

    useEffect(() => {
        if (! isShowModal) {
            firstInteraction.current = true;
        }
    }, [ isShowModal ]);

    const submitedText = count > 0 ? `Показать ${formatNumber(count)}` : 'Нет объявлений';

    const realtyType = (filters.get(Filters.categoryType) as CategoryTypeFilter).categoryType;

    const renderHouseFilters = filters.isLandFilterActive() ? null : (<>
        <div className={cn('filter-group-title', { other: true })}>
            {filters.isOnlyNewBuildings() ? 'Срок сдачи' : 'Год постройки'}
        </div>
        <div className={cn('w228')}>
            {
                filters.isOnlyNewBuildings() ?
                    <CommissioningDateFilter
                        filter={filters.get(Filters.commissioning)}
                        handleChange={updateFilter}
                        classNameGroup={cn('grid-house-category')}
                    /> :
                    <YearBuildingFilterView
                        withoutTitle
                        withoutEpochTitle
                        filter={filters.get(Filters.builtYear)}
                        handleChange={updateFilter}
                        filter2={filters.get(Filters.buildEpoch)}
                        isNewBuilding={filters.isOnlyNewBuildings()}
                    />
            }
        </div>
        <div className={cn('filter-group-title')}>Этажей в доме</div>
        <div className={cn('w228')}>
            <FloorsTotalFilterView
                withoutTitle
                filter={filters.get(Filters.floorsTotal)}
                handleChange={updateFilter}
            />
        </div>
    </>);

    const getTitle = () => {
        if (filters.isFlatFilterActive()) return 'Квартира';
        if (filters.isRoomFilterActive()) return 'Комната';
        if (filters.isHouseFilterActive()) return 'Дом';
        if (filters.isLandFilterActive()) return 'Участок';

        return 'Квартира';
    };

    return (<>
        <DSModal
            size='l'
            opened={isShowModal}
            onClose={handleClose}
            overflow={false}
        >
            {filters.isRentFilterActive() && (<>
                <DSModal.Title>
                    Объявление
                </DSModal.Title>
                <div className={cn()}>
                    <div className={cn()} onClick={handleInteraction}>
                        <div className={cn('filter-group-title')}>Автор объявления</div>
                        <div className={cn('grid-filter-group', { floor: true })}>
                            <SellerFilter
                                filter={filters.get(Filters.author)}
                                handleChange={updateFilter}
                                classNameGroup={cn('grid-filter-subgroup', { seller: true })}
                                isSecond
                            />
                        </div>
                        <div className={cn('filter-group-title', { floor: filters.isFlatOrRoomFilterActive() })}>
                            Условия
                        </div>
                        <div className={cn('grid-filter-group')}>
                            <RentConditionButtonFilterView
                                handleChange={updateFilter}
                                conditionFilter={filters.get(Filters.rentConditions)}
                                tenantOptionFilter={filters.get(Filters.livingTenantOptions)}
                                isHouse={filters.isHouseFilterActive()}
                                classNameGroup={cn('flex-subgroup')}

                            />
                        </div>
                        {filters.isFlatFilterActive() && (<>
                            <div className={cn('filter-group-title')}>Апартаменты</div>
                            <div className={cn('grid-filter-group')}>
                                <ApartmentButtonFilterView
                                    filter={filters.get(Filters.apartments)}
                                    handleChange={updateFilter}
                                    classNameGroup={cn('flex-subgroup')}
                                />
                            </div>
                        </>)}
                        <div className={cn('filter-group-title')}>Предоплата</div>
                        <div className={cn('grid-filter-group')}>
                            <PrePaymentButtonFilterView
                                filter={filters.get(Filters.rentPrepayment)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ marginBottom: '32px' }} />
            </>)}
            {filters.hasMetroInRegion() && filters.isRentFilterActive() && (<>
                <DSModal.Title>
                    Расположение
                </DSModal.Title>
                <div className={cn()}>
                    <div className={cn()} onClick={handleInteraction}>
                        <div className={cn('filter-group-title', { floor: true })}>До метро</div>
                        <div className={cn('grid-filter-group')}>
                            <TransportLimitNewFilter
                                filter={filters.get(Filters.transportLimit)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ marginBottom: '32px' }} />
            </>)}
            <DSModal.Title>
                {getTitle()}
            </DSModal.Title>
            <div className={cn()}>
                <div className={cn()} onClick={handleInteraction}>
                    {filters.isFlatOrRoomFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Площадь</div>
                        <div className={cn('grid-filter-group', { area: true })}>
                            <AreaFilterView
                                withoutTitle
                                filter={filters.get(Filters.totalArea)}
                                handleChange={updateFilter}
                            />
                            <KitchenAreaFromFilterView
                                withoutTitle
                                withPlaceholder
                                filter={filters.get(Filters.kitchenArea)}
                                handleChange={updateFilter}
                            />
                            {filters.isFlatFilterActive() && (
                                <LivingAreaFromFilterView
                                    withoutTitle
                                    filter={filters.get(Filters.livingArea)}
                                    handleChange={updateFilter}
                                />
                            )}
                        </div>
                    </>)}
                    {filters.isHouseFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Площадь дома</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <DesktopHouseAreaFilterView
                                withoutTitle
                                filter={filters.get(Filters.houseArea)}
                                handleChange={updateFilter}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Комнат в доме</div>
                        <DesktopRoomInHouseFilterSelectView
                            filter={filters.get(Filters.rooms)}
                            handleChange={updateFilter}
                            withoutTitle
                            classNameGroup={cn('grid-filter-subgroup', { rooms: true })}
                        />
                        <div className={cn('filter-group-title')}>Площадь участка</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <DesktopLandAreaFilterView
                                withoutTitle
                                filter={filters.get(Filters.landArea)}
                                handleChange={updateFilter}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Статус участка</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <DesktopLandStatusFilterView
                                size='s'
                                defaultPlaceholder={<Typography color='black-300'>Неважно</Typography>}
                                filter={filters.get(Filters.landStatus)}
                                onChange={updateFilter}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Мебель</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <FurnitureButtonFilterView
                                filter={filters.get(Filters.furniture)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                                // Для домов такая же логика как и для комнат
                                isRoom
                            />
                        </div>
                        {renderHouseFilters}
                    </>)}
                    {filters.isLandFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Площадь участка</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <DesktopLandAreaFilterView
                                withoutTitle
                                filter={filters.get(Filters.landArea)}
                                handleChange={updateFilter}
                            />
                        </div>
                    </>)}
                    {filters.isLandOrHouseFilterActive() && (<>
                        <div className={cn('filter-group-title', { floor: filters.isHouseFilterActive() })}>
                            Коммуникации
                        </div>
                        <SupplyOptionsButtonFilterView
                            supplyFilter={filters.get(Filters.supplyOptions)}
                            heatingFilter={filters.isHouseFilterActive() ? filters.get(Filters.heating) : undefined}
                            bathroomLocationFilter={filters.get(Filters.bathroomLocation)}
                            handleChangeSupply={updateFewFilters}
                            handleChange={updateFilter}
                            classNameGroup={cn('flex-subgroup')}
                        />
                        {filters.isRentFilterActive() && (<>
                            <div className={cn('filter-group-title', { floor: true })}>Удобства</div>
                            <div className={cn('grid-filter-group')}>
                                <LivingFacilityButtonFilterView
                                    filter={filters.get(Filters.livingFacility)}
                                    handleChange={updateFilter}
                                    classNameGroup={cn('flex-subgroup')}
                                />
                            </div>
                        </>)}
                    </>)}
                    {filters.isFlatFilterActive() && ! filters.isRentFilterActive() && (<>
                        {
                            ! filters.isOnlySecond() &&
                            <>
                                <div className={cn('filter-group-title')}>Отделка</div>
                                <div className={cn('grid-filter-group')}>
                                    <FinishingFilterView
                                        filter={filters.get(Filters.finishingType)}
                                        handleChange={updateFilter}
                                        classNameGroup={cn('flex-subgroup')}
                                    />
                                </div>
                            </>
                        }
                        <div className={cn('filter-group-title')}>Апартаменты</div>
                        <div className={cn('grid-filter-group')}>
                            <ApartmentButtonFilterView
                                filter={filters.get(Filters.apartments)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Продавец</div>
                        <div className={cn('grid-filter-group', { floor: true })}>
                            <SellerFilter
                                filter={filters.get(Filters.author)}
                                handleChange={updateFilter}
                                classNameGroup={cn('grid-filter-subgroup', { seller: true })}
                                isSecond={filters.isOnlySecond()}
                            />
                        </div>
                    </>)}
                    {filters.isRoomFilterActive() && ! filters.isRentFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Комнат в квартире</div>
                        <DesktopRoomInFlatFilterView
                            classNameGroup={cn('grid-filter-subgroup', { rooms: true })}
                            filter={filters.get(Filters.rooms)}
                            handleChange={updateFilter}
                            withoutTitle
                        />
                        <div className={cn('filter-group-title')}>Комнат на продажу</div>
                        <DesktopRoomsInOfferFilterView
                            classNameGroup={cn('grid-filter-subgroup', { rooms: true })}
                            filter={filters.get(Filters.roomsInOffer)}
                            dealType={filters.getDealTypeFilter().dealType}
                            handleChange={updateFilter}
                            withoutTitle
                        />
                    </>)}
                    {filters.isFlatOrRoomFilterActive() && (<>
                        {
                            ! filters.isOnlyNewBuildings() &&
                            <>
                                <div className={cn('filter-group-title')}>Ремонт</div>
                                <div className={cn('grid-filter-group', { floor: true })}>
                                    <RenovationNewFilter
                                        filter={filters.get(Filters.renovation)}
                                        handleChange={updateFilter}
                                        classNameGroup={cn('flex-subgroup')}
                                    />
                                </div>
                            </>
                        }
                        <div className={cn('filter-group-title', { floor: true })}>Этаж</div>
                        <div className={cn('grid-filter-group', { floor: true })}>
                            <FloorFilterView
                                withoutTitle
                                withoutGrid
                                classNameGroup={cn('grid-filter-subgroup', { floor: true })}
                                filter={filters.get(Filters.floor)}
                                handleChange={updateFilter}
                            />
                        </div>
                        {filters.isRentFilterActive() && (<>
                            <div className={cn('filter-group-title', { floor: true })}>Удобства</div>
                            <div className={cn('grid-filter-group')}>
                                <LivingFacilityButtonFilterView
                                    filter={filters.get(Filters.livingFacility)}
                                    handleChange={updateFilter}
                                    classNameGroup={cn('flex-subgroup')}
                                />
                            </div>
                        </>)}
                        <div className={cn('filter-group-title')}>Высота потолков</div>
                        <div className={cn('grid-filter-group')}>
                            <CeilHeightNewFilterView
                                classNameGroup={cn('grid-filter-subgroup', { cell: true })}
                                filter={filters.get(Filters.cellHeight)}
                                handleChange={updateFilter}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Санузел</div>
                        <div className={cn('grid-filter-group')}>
                            <BathroomNewFilterView
                                filter={filters.get(Filters.bathroom)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                        <div className={cn('filter-group-title')}>Вид из окна</div>
                        <div className={cn('grid-filter-group')}>
                            <WindowDirectionNewFilter
                                filter={filters.get(Filters.windowsDirection)}
                                handleChange={updateFilter}
                                classNameGroup={cn('grid-filter-subgroup', { cell: true })}
                            />
                        </div>
                        {(filters.isRentFlatOrRoomFilterActive() || filters.isSellFlatFilterActive()) &&
                        ! filters.isOnlyNewBuildings() && (<>
                            <div className={cn('filter-group-title')}>Мебель</div>
                            <div className={cn('grid-filter-group')}>
                                <FurnitureButtonFilterView
                                    filter={filters.get(Filters.furniture)}
                                    handleChange={updateFilter}
                                    isRoom={filters.isRoomFilterActive()}
                                    classNameGroup={cn('flex-subgroup')}
                                />
                            </div>
                        </>)}
                        <div className={cn('filter-group-title')}>Балкон</div>
                        <div className={cn('grid-filter-group')}>
                            <BalconyNewFilter
                                filter={filters.get(Filters.balcony)}
                                handleChange={updateFilter}
                                classNameGroup={cn('grid-filter-subgroup', { cell: true })}
                            />
                        </div>
                    </>)}
                </div>
            </div>
            {filters.hasMetroInRegion() && filters.isSellFilterActive() && (<>
                <div className={cn('margin')} />
                <DSModal.Title>
                    Расположение
                </DSModal.Title>
                <div className={cn()}>
                    <div className={cn()} onClick={handleInteraction}>
                        <div className={cn('filter-group-title', { floor: true })}>До метро</div>
                        <div className={cn('grid-filter-group')}>
                            <TransportLimitNewFilter
                                filter={filters.get(Filters.transportLimit)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                    </div>
                </div>
            </>)}
            {filters.isFlatOrRoomFilterActive() && (<>
                <div className={cn('margin')} />
                <DSModal.Title>
                    Дом
                </DSModal.Title>
                <div className={cn()}>
                    <div className={cn()} onClick={handleInteraction}>
                        <div className={cn('filter-group-title', { floor: true })}>Материал стен</div>
                        <div className={cn('grid-filter-group')}>
                            <DesktopWallsButtonFilterView
                                filter={filters.get(Filters.walls)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                        {renderHouseFilters}
                        <div className={cn('filter-group-title')}>Ещё</div>
                        <div className={cn('grid-filter-group')}>
                            <InfrastructureButtonFilterView
                                filter={filters.get(Filters.infrastructure)}
                                parkingFilter={filters.get(Filters.parkings)}
                                handleChange={updateFilter}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                        {filters.isRenovationProgramFilterActive() && (<>
                            <div className={cn('filter-group-title')}>Реновация</div>
                            <div className={cn('grid-filter-group')}>
                                <RenovationProgramButtonFilterView
                                    filter={filters.get(Filters.renovationProgram)}
                                    handleChange={updateFilter}
                                />
                            </div>
                        </>)}
                    </div>
                </div>
                <div className={cn('margin')} />
                <DSModal.Title>
                    Район
                </DSModal.Title>
                <div className={cn()}>
                    <div className={cn()} onClick={handleInteraction}>
                        <div className={cn('filter-group-title')}>Рядом</div>
                        <div className={cn('grid-filter-group')}>
                            <NearbySchoolButtonFilterView
                                filter={filters.get(Filters.nearbyOptions)}
                                handleChange={updateFilter}
                            />
                        </div>
                    </div>
                </div>
            </>)}
            <div className={cn('margin')} />
            <DSModal.Title>
                Дополнительно
            </DSModal.Title>
            <div className={cn()}>
                <div className={cn()} onClick={handleInteraction}>
                    {filters.isSellFilterActive() && (<>
                        <div className={cn('filter-group-title', { floor: ! filters.isLandOrHouseFilterActive() })}>
                            Объявление
                        </div>
                        <div className={cn('grid-filter-group')}>
                            <AdditionalButtonFilterView
                                photoFilter={filters.get(Filters.photoOptions)}
                                onlineViewFilter={filters.get(Filters.onlineView)}
                                layoutImageOptionFilter={filters.get(Filters.layoutImageOptions)}
                                pitFilter={filters.get(Filters.author)}
                                handleChange={updateFilter}
                                isLandOrHouse={filters.isLandOrHouseFilterActive()}
                                isNewBuilding={filters.isOnlyNewBuildings()}
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                    </>)}
                    {filters.isRentFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Объявление</div>
                        <div className={cn('grid-filter-group')}>
                            <AdditionalButtonFilterView
                                photoFilter={filters.get(Filters.photoOptions)}
                                onlineViewFilter={filters.get(Filters.onlineView)}
                                layoutImageOptionFilter={filters.get(Filters.layoutImageOptions)}
                                pitFilter={filters.get(Filters.author)}
                                handleChange={updateFilter}
                                isLandOrHouse={! filters.isFlatFilterActive()}
                                isNewBuilding
                                classNameGroup={cn('flex-subgroup')}
                            />
                        </div>
                    </>)}
                    { filters.isSellFlatOrRoomFilterActive() && (<>
                        <div className={cn('filter-group-title')}>Тип сделки</div>
                        <div className={cn('grid-filter-group', { wExcept132: true })}>
                            <SellTypeSelectFilterView
                                filter={filters.get(Filters.sellType)}
                                isRoom={realtyType === RealtyObjectType.ROOM}
                                handleChange={updateFilter}
                                withoutTitle
                            />
                        </div>
                    </>)}
                </div>
                {/*{firstInteraction.current || ! showPromoRieltors ? null : (*/}
                {/*    <ClPromoRieltorsTrigger*/}
                {/*        regionId={filters.getRegionFilter().region}*/}
                {/*        view='filters'*/}
                {/*    />*/}
                {/*)}*/}
                <DSModal.Actions>
                    <div className={cn('buttons')}>
                        <div className={cn('buttons-left')}>
                            <Button
                                fullWidth
                                width={224}
                                dataTest='filter-more-submit'
                                onClick={onSubmit}
                            >
                                {submitedText}
                            </Button>
                            <Button
                                fullWidth
                                width={224}
                                variant='secondary'
                                dataTest='filter-more-map'
                                onClick={onSwitchMap}
                                icon='map'
                                iconPosition='start'
                            >
                                Показать на карте
                            </Button>
                        </div>
                        <Button
                            fullWidth
                            width={110}
                            dataTest='filter-more-reset'
                            onClick={handleReset}
                            variant='transparent'
                        >
                            Сбросить
                        </Button>
                    </div>
                </DSModal.Actions>
            </div>
        </DSModal>
        <div className={cn('filters-trigger')}>
            <Button
                role='listbox'
                variant='secondary'
                dataTest='filter-more-show'
                icon='settings'
                onClick={handleOpen}
            >
                Фильтры
            </Button>
        </div>
    </>);
};
